import _extends from "reshow-runtime/es/helpers/extends";
import _slicedToArray from "reshow-runtime/es/helpers/slicedToArray";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import React, { useState, useRef, useEffect } from "react";
import { reactStyle, SemanticUI } from "react-atomic-molecule";
import getKeyframe from "keyframe-css";
import { doc } from "win-doc";
import AnimateGroup from "../organisms/AnimateGroup";
var inject = {};

var init = function init(key, ani, timeout) {
  if (inject[key] || doc().__null) {
    return;
  }

  reactStyle(_objectSpread({
    animationName: [ani],
    animationDuration: [timeout * 1 + 30 + "ms"]
  }, Styles.linear), "." + key, key); // Need locate after reactStyle, for inject latest style in getKeyframe function

  getKeyframe(ani);
  inject[key] = true;
};

var parseAniValue = function parseAniValue(s) {
  var data = s.split("-");
  var name = data[0];
  var timeout = 500;
  var delay = 0;

  if (!isNaN(data[1])) {
    timeout = parseInt(data[1], 10);
  }

  if (!isNaN(data[2])) {
    delay = parseInt(data[2], 10);
    timeout += delay;
  }

  var key = [name, timeout, delay].join("-");
  return {
    className: key + " " + name,
    key: key,
    name: name,
    timeout: timeout,
    delay: delay
  };
};

var Animate = function Animate(props) {
  var appear = props.appear,
      enter = props.enter,
      leave = props.leave,
      others = _objectWithoutProperties(props, ["appear", "enter", "leave"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      isLoad = _useState2[0],
      setIsLoad = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      aniConf = _useState4[0],
      setAniConf = _useState4[1];

  useEffect(function () {
    var that = {};
    var data;

    if (appear) {
      data = parseAniValue(appear);
      that.appear = data.name;
      that.appearKey = data.key;
      that.appearTimeout = data.timeout;
      that.appearDelay = data.delay;
      that.appearClass = data.className;
      init(that.appearKey, that.appear, that.appearTimeout);
    }

    if (enter) {
      data = parseAniValue(enter);
      that.enter = data.name;
      that.enterKey = data.key;
      that.enterTimeout = data.timeout;
      that.enterDelay = data.delay;
      that.enterClass = data.className;
      init(that.enterKey, that.enter, that.enterTimeout);
    }

    if (leave) {
      data = parseAniValue(leave);
      that.leave = data.name;
      that.leaveKey = data.key;
      that.leaveTimeout = data.timeout;
      that.leaveDelay = data.delay;
      that.leaveClass = data.className;
      init(that.leaveKey, that.leave, that.leaveTimeout);
    }

    setAniConf(that);
    setTimeout(function () {
      return setIsLoad(true);
    });
  }, [appear, enter, leave, isLoad]);
  return isLoad ? /*#__PURE__*/React.createElement(AnimateGroup, _extends({
    timeout: {
      appear: aniConf.appearTimeout,
      enter: aniConf.enterTimeout,
      exit: aniConf.leaveTimeout
    },
    delay: {
      appear: aniConf.appearDelay,
      enter: aniConf.enterDelay,
      exit: aniConf.leaveDelay
    },
    classNames: {
      appear: aniConf.appearClass,
      enter: aniConf.enterClass,
      exit: aniConf.leaveClass
    },
    appear: !!appear,
    enter: !!enter,
    exit: !!leave
  }, others)) : null;
};

Animate.defaultProps = {
  component: SemanticUI,
  appear: null,
  enter: null,
  leave: null
};
export default Animate;
var Styles = {
  linear: {
    animationIterationCount: [1],
    animationTimingFunction: ["linear"]
  }
};